"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionService = exports.PermissionGroup = void 0;
const types_1 = require("../shared/types");
var PermissionGroup;
(function (PermissionGroup) {
    PermissionGroup[PermissionGroup["PU_COMPLETED"] = 0] = "PU_COMPLETED";
    PermissionGroup[PermissionGroup["PU_COMPLETED_MBB"] = 1] = "PU_COMPLETED_MBB";
    PermissionGroup[PermissionGroup["PU"] = 2] = "PU";
    PermissionGroup[PermissionGroup["SU"] = 3] = "SU";
    PermissionGroup[PermissionGroup["GU"] = 4] = "GU";
    PermissionGroup[PermissionGroup["GU_WCAR"] = 5] = "GU_WCAR";
    PermissionGroup[PermissionGroup["WCAR"] = 6] = "WCAR";
    PermissionGroup[PermissionGroup["MBB"] = 7] = "MBB";
    PermissionGroup[PermissionGroup["VIN"] = 8] = "VIN";
    PermissionGroup[PermissionGroup["COMMISSION"] = 9] = "COMMISSION";
})(PermissionGroup || (exports.PermissionGroup = PermissionGroup = {}));
class PermissionService {
    hasPermission(permissionData, ...permissionGroups) {
        return permissionGroups.filter((group) => this.hasSinglePermission(group, permissionData)).length > 0;
    }
    hasSinglePermission(permissionGroup, permissionData) {
        // @formatter:off
        switch (permissionGroup) {
            case PermissionGroup.PU_COMPLETED:
                return permissionData.role === types_1.Role.PRIMARY_USER && permissionData.enrollmentStatus === types_1.EnrollmentStatus.COMPLETED;
            case PermissionGroup.PU_COMPLETED_MBB:
                return this.hasAllPermissions(permissionData, PermissionGroup.PU_COMPLETED, PermissionGroup.MBB);
            case PermissionGroup.PU:
                return permissionData.role === types_1.Role.PRIMARY_USER;
            case PermissionGroup.SU:
                return permissionData.role === types_1.Role.SECONDARY_USER;
            case PermissionGroup.GU:
                return permissionData.role === types_1.Role.GUEST_USER;
            case PermissionGroup.GU_WCAR:
                return permissionData.role === types_1.Role.GUEST_USER && permissionData.devicePlatform === types_1.DevicePlatform.WCAR;
            case PermissionGroup.WCAR:
                return permissionData.devicePlatform === types_1.DevicePlatform.WCAR;
            case PermissionGroup.MBB:
                return permissionData.devicePlatform === types_1.DevicePlatform.MBB || permissionData.devicePlatform === types_1.DevicePlatform.MBB_ODP;
            case PermissionGroup.VIN:
                return !!permissionData.vin;
            case PermissionGroup.COMMISSION:
                return !!permissionData.commissionNumber && !!permissionData.commissionNumberYear;
        }
        return false;
        // @formatter:on
    }
    hasAllPermissions(permissionData, ...permissionGroups) {
        return permissionGroups.filter((group) => this.hasSinglePermission(group, permissionData)).length === permissionGroups.length;
    }
}
exports.PermissionService = PermissionService;
//# sourceMappingURL=PermissionService.js.map